import React from 'react'

interface InfoStripProps {
  title?: string
  text: string
}

const InfoStrip: React.FC<InfoStripProps> = ({ title, text }) => {
  return (
    <div className="border-l-4 border-blue flex items-center gap-2 bg-really-light-blue p-3 text-sm text-muted rounded-e-lg">
      <p>
        {title && <b className="text-body-soft">{title} </b>}
        {text}
      </p>
    </div>
  )
}

export default InfoStrip
